import { useParams } from "react-router-dom";
// Redux
import { useSelector } from "react-redux";
// Constants - Functions
import { pathHomePage } from "../../../../../config/constants";
// Components
import { SessionMainDiv, SessionDiv, SessionText, DetailsDiv, DetailsLink, DetailsImg } from "./styles";
// Assets
import IcoDetails from "../../../../../assets/icons/ico_details.svg";

const SessionData = ({ sessionNumber, date, startTime, endTime, totalTime }) => {
  const clinicianToken = useSelector(({ clinician }) => clinician.data.token);
  const { patientId } = useParams();

  return (
    <SessionMainDiv>
      <SessionDiv>
        <SessionText width="100px">{sessionNumber}</SessionText>
        <SessionText width="170px">{date}</SessionText>
        <SessionText width="170px">{startTime}</SessionText>
        <SessionText width="170px">{endTime}</SessionText>
        <SessionText width="170px">{totalTime}</SessionText>
        <DetailsDiv width="80px">
          <DetailsLink to={`${pathHomePage}/sessions/icu/${clinicianToken}/${patientId}/${sessionNumber}`}>
            <DetailsImg src={IcoDetails} alt="ico-details" />
          </DetailsLink>
        </DetailsDiv>
      </SessionDiv>
    </SessionMainDiv>
  );
};

export default SessionData;
